<template>
  <div class="mb-5">
    <div class="alert alert-info">
      <p>
        Before reading the Tutorial,
        <a :href="botLink" target="_blank">
          Please go through the demo by clicking here.
        </a>
      </p>
    </div>
    <h4>Get Bot Token From BotFather</h4>
    <p>
      Before you can create the bot, you need to get the bot token from the Telegram, You can get your bot token from @botfather. BotFather is a Telegram's official bot to create the bots.
      <a
        href="https://t.me/botfather"
        target="_blank"
      >To chat with BotFather click here</a> or go to Telegram app and search for @botfather.
      Start the bot and send "/newbot" and follow the instructions, in the end, you will get your bot token, copy and keep it ready.
    </p>
  </div>
</template>

<script>
export default {
  props:{
    botLink: String
  }
};
</script>

<style>
</style>